/*
 * DSD Share Sheet – p11dz96
 * Canonical share owner for post/feed share actions.
 */
(function(){
  if (window.DSDShareSheet && window.DSDShareSheet.version) return;

  var VERSION = 'p11dz96-canonical-share-sheet-post-action-slot-v1';
  var BUTTON_SELECTOR = '[data-dsd-action="share"],.dsd-share-button';
  var CARD_SELECTOR = '.dsd-post-card,[data-dsd-contract="canonical-post-card"]';

  function claim(surface, meta){
    try {
      if (window.DSDRegistry && typeof window.DSDRegistry.claim === 'function') {
        window.DSDRegistry.claim(surface, 'ShareSheet', Object.assign({ version: VERSION }, meta || {}));
      }
    } catch(e) {}
  }
  function violation(code, message, meta){
    try {
      if (window.DSDRegistry && typeof window.DSDRegistry.reportViolation === 'function') {
        window.DSDRegistry.reportViolation(code, message, Object.assign({ version: VERSION }, meta || {}));
      }
    } catch(e) {}
  }
  function ensureAnchor(){
    var anchor = document.querySelector('[data-dsd-owner="ShareSheet"]');
    if (!anchor) {
      anchor = document.createElement('div');
      anchor.setAttribute('data-dsd-owner', 'ShareSheet');
      anchor.setAttribute('data-dsd-contract', 'share-sheet-controller');
      anchor.setAttribute('aria-live', 'polite');
      anchor.hidden = true;
      anchor.setAttribute('aria-hidden', 'true');
      document.body.appendChild(anchor);
    }
    claim('share-sheet:anchor-present', {
      anchors: ['[data-dsd-owner="ShareSheet"]', BUTTON_SELECTOR],
      count: document.querySelectorAll('[data-dsd-owner="ShareSheet"],'+BUTTON_SELECTOR).length
    });
    return anchor;
  }
  function text(value, fallback){ return (value === undefined || value === null || value === '') ? (fallback || '') : String(value); }
  function getCard(target){ return target && target.closest ? target.closest(CARD_SELECTOR) : null; }
  function getTitle(card){
    if (!card) return document.title || 'Detroit Sky Daddy';
    var title = card.getAttribute('data-post-title') || '';
    if (!title) {
      var el = card.querySelector('.dsd-post-title,[data-dsd-post-title],h2,h3');
      title = el && el.textContent ? el.textContent.trim() : '';
    }
    return text(title, document.title || 'Detroit Sky Daddy');
  }
  function getUrl(card){
    var url = window.location.href.split('#')[0];
    var postId = card && (card.getAttribute('data-post-id') || card.dataset.postId);
    if (postId) url += '#post-' + encodeURIComponent(postId);
    return url;
  }
  function copyText(value){
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(value);
    return new Promise(function(resolve, reject){
      try {
        var input = document.createElement('textarea');
        input.value = value;
        input.setAttribute('readonly', 'readonly');
        input.style.position = 'fixed';
        input.style.top = '-1000px';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        resolve();
      } catch(e) { reject(e); }
    });
  }
  function recordShare(payload, mode){
    try {
      if (window.DSDLaunchSocial && typeof window.DSDLaunchSocial.recordShare === 'function' && payload && payload.postId) {
        window.DSDLaunchSocial.recordShare(payload.postId, mode || 'link');
      }
    } catch(e) {}
  }
  function buildPayload(card){
    return { title: getTitle(card), text: getTitle(card), url: getUrl(card), postId: card && (card.getAttribute('data-post-id') || card.dataset.postId) || null };
  }
  function announce(message){
    var anchor = ensureAnchor();
    anchor.hidden = false;
    anchor.removeAttribute('aria-hidden');
    anchor.textContent = message || '';
    window.setTimeout(function(){
      anchor.textContent = '';
      anchor.hidden = true;
      anchor.setAttribute('aria-hidden', 'true');
    }, 1600);
  }
  function ensureButtons(){
    var cards = Array.prototype.slice.call(document.querySelectorAll(CARD_SELECTOR));
    var added = 0;
    cards.forEach(function(card){
      if (!card || card.querySelector(BUTTON_SELECTOR)) return;
      var actions = card.querySelector('.dsd-post-actions') || card;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dsd-share-button';
      btn.dataset.dsdAction = 'share';
      btn.dataset.dsdOwner = 'ShareSheet';
      btn.setAttribute('aria-label', 'Share post');
      var label = document.createElement('span');
      label.className = 'dsd-share-label';
      label.textContent = 'Share';
      btn.appendChild(label);
      actions.appendChild(btn);
      added += 1;
    });
    claim('share-sheet:buttons-bound', {
      cards: cards.length,
      added: added,
      buttons: document.querySelectorAll(BUTTON_SELECTOR).length,
      postActionSlots: document.querySelectorAll('.dsd-post-card .dsd-post-actions [data-dsd-action="share"],.dsd-post-card .dsd-post-actions .dsd-share-button').length
    });
  }

  var api = {
    version: VERSION,
    refresh: function(){
      ensureAnchor();
      ensureButtons();
      claim('share-sheet:mounted', { mode: 'delegated-native-or-copy-no-modal', selector: BUTTON_SELECTOR, buttons: document.querySelectorAll(BUTTON_SELECTOR).length });
    },
    openFromElement: function(target){
      ensureAnchor();
      var payload = buildPayload(getCard(target));
      if (navigator.share && api.nativeShare(payload)) {
        claim('share-sheet:native-opened', { postId: payload.postId, hasNativeShare: true });
        return true;
      }
      return copyText(payload.url).then(function(){
        announce('Link copied.');
        claim('share-sheet:link-copied', { postId: payload.postId || null, mode: 'direct-copy-no-modal' });
        recordShare(payload, 'copy');
        return true;
      }).catch(function(){
        violation('SHARE_SHEET_COPY_FAILED', 'ShareSheet could not copy link.', { url: payload.url });
        return false;
      });
    },
    nativeShare: function(payload){
      payload = payload || buildPayload(null);
      if (!navigator.share) return false;
      try {
        navigator.share({ title: payload.title, text: payload.text, url: payload.url }).then(function(){ claim('share-sheet:native-shared', { postId: payload.postId || null }); recordShare(payload, 'native'); }).catch(function(err){
          if (err && err.name === 'AbortError') return;
          violation('SHARE_SHEET_NATIVE_FAILED', 'Native share failed.', { postId: payload.postId || null });
        });
        return true;
      } catch(e) { violation('SHARE_SHEET_NATIVE_FAILED', 'Native share failed.', { postId: payload.postId || null }); return false; }
    },
    close: function(){ return true; }
  };
  function onClick(event){
    var btn = event.target && event.target.closest ? event.target.closest(BUTTON_SELECTOR) : null;
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    api.openFromElement(btn);
  }
  function boot(){
    ensureAnchor();
    claim('share-sheet:asset-global-present', { status: 'ready', globals: ['DSDShareSheet'] });
    api.refresh();
    document.addEventListener('click', onClick, true);
    if (window.DSDRegistry && typeof window.DSDRegistry.trackListener === 'function') {
      try { window.DSDRegistry.trackListener({ id: 'ShareSheet:delegated-click', owner: 'ShareSheet', type: 'click', target: 'document', capture: true, passive: false, once: false }); } catch(e) {}
    }
  }
  window.DSDShareSheet = api;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
